import styled, { css } from 'styled-components';

export const OptionList = styled.div`
  text-align: left;
  display: grid;
  grid-gap: 8px;
`;

export const Option = styled.div<{
  isActive?: boolean;
  isDisabled?: boolean;
  isSimple?: boolean;
  withoutScale?: boolean;
}>`
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  position: relative;
  padding: 12px 24px 12px 42px;
  color: ${({ theme }) => theme.secondary.background};
  border-radius: 8px;
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.secondary.blendToBackground(200)};
  transition:
    box-shadow 0.2s,
    background-color 0.2s,
    color 0.2s,
    transform 0.2s;
  opacity: ${({ isDisabled }) => (isDisabled ? '.8' : '1')};

  ${({ withoutScale, isDisabled }) =>
    !withoutScale &&
    !isDisabled &&
    css`
      transform: translateZ(0);

      &:active {
        transform: scaleX(0.985) scaleY(0.975) translateZ(0);
      }
    `}

  & > * {
    z-index: 1;
    position: relative;
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    transition: opacity 0.2s;
    opacity: 0;
  }

  &:before {
    background-image: linear-gradient(
      to bottom right,
      ${({ theme }) => theme.primary.blendToBackground(100)},
      ${({ theme }) => theme.background}
    );
  }

  &:after {
    box-shadow: inset 0 0 0 2px ${({ theme }) => theme.primary.blendToBackground(600)};
    z-index: 1;
    pointer-events: none;
  }

  ${({ isActive, isDisabled }) =>
    !isActive &&
    !isDisabled &&
    css`
      &:hover {
        box-shadow: inset 0 0 0 1px ${({ theme }) => theme.secondary.blendToBackground(400)};
      }
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      &:before,
      &:after {
        opacity: 1;
      }
    `}

  ${({ isSimple }) =>
    isSimple &&
    css`
      padding: 12px;
    `}
`;

export const OptionLabel = styled.span`
  flex-grow: 1;
  display: block;
  line-height: 20px;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  z-index: 1;
`;
